module.exports = __webpack_public_path__ + "static/media/Gemo.477e308d.svg";